<template>
  <div class="cart-page page">
    <BreadcrumbsComponent @back.prevent :links="links"/>
    <div class="cart-page__container sides-padding">
      <div class="container">
        <div class="cart-page__content">
          <div class="cart-page__body">
            <ProductsTableComponent
              v-if="cartItems && cartItems.length"
              @countChange="countChange"
              @remove="remove"
              :items="cartItems"
            />
            <span v-else>Корзина пуста</span>
            <div class="cart-page__dropdowns">
              <!--              <CartDropdownComponent title="Регион доставки">-->
              <!--                <div ref="deliveryForm" class="form">-->
              <!--                  <div class="form__row">-->
              <!--                    <div class="form__col-6">-->
              <!--                      <InputComponent-->
              <!--                        v-model="deliveryForm.city.value"-->
              <!--                        title="Город*"-->
              <!--                        :subtitle="deliveryForm.city.message"-->
              <!--                        :error="deliveryForm.city.error"-->
              <!--                      />-->
              <!--                    </div>-->
              <!--                    <div class="form__col-6">-->
              <!--                      <InputComponent-->
              <!--                        v-model="deliveryForm.index.value"-->
              <!--                        title="Индекс*"-->
              <!--                        mask="######"-->
              <!--                        :subtitle="deliveryForm.index.message"-->
              <!--                        :error="deliveryForm.index.error"-->
              <!--                      />-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </CartDropdownComponent>-->
              <CartDropdownComponent title="Данные покупателя">
                <div ref="recipientForm" class="form">
                  <div class="form__row">
                    <div class="form__col-4">
                      <InputComponent
                        v-model="recipientForm.surname.value"
                        title="Фамилия*"
                        :subtitle="recipientForm.surname.message"
                        :error="recipientForm.surname.error"
                      />
                    </div>
                    <div class="form__col-4">
                      <InputComponent
                        v-model="recipientForm.name.value"
                        title="Имя*"
                        :subtitle="recipientForm.name.message"
                        :error="recipientForm.name.error"
                      />
                    </div>
                    <div class="form__col-4">
                      <InputComponent
                        v-model="recipientForm.patronymic.value"
                        title="Отчество"
                        :subtitle="recipientForm.patronymic.message"
                        :error="recipientForm.patronymic.error"
                      />
                    </div>
                    <div class="form__col-6">
                      <InputComponent
                        v-model="recipientForm.phone.value"
                        title="Телефон*"
                        mask="+7 (###) ### - ## - ##"
                        :subtitle="recipientForm.phone.message"
                        :error="recipientForm.phone.error"
                      />
                    </div>
                    <div class="form__col-6">
                      <InputComponent
                        v-model="recipientForm.email.value"
                        title="Email"
                        :subtitle="recipientForm.email.message"
                        :error="recipientForm.email.error"
                      />
                    </div>
                  </div>
                </div>
                <CheckboxComponent :checked="subscription" @change="subscription = !subscription">
                  <span> Хочу получать наши Спецпредложения и Акции </span>
                </CheckboxComponent>
              </CartDropdownComponent>
              <CartDropdownComponent title="Способ доставки">
                <div class="cart-page__methods">
                  <RadioComponent
                    v-for="(item, i) in deliveries"
                    :key="i"
                    :checked="isChecked(item, 'delivery_type_id')"
                    @change="changeRadio($event, item, 'delivery_type_id')"
                    :hideState="true"
                  >
                    <MethodComponent
                      :class="{ 'method--active': isChecked(item, 'delivery_type_id') }"
                      :title="item.title"
                      :icon="item.icon"
                      :description="item.description"
                    />
                  </RadioComponent>
                </div>
                <div
                  v-if="
                    deliveryForm.delivery_type_id.value &&
                    deliveryForm.delivery_type_id.value.type === types.PICKUP
                  "
                  class="cart-page__shop"
                >
                  <SelectComponent
                    v-model="deliveryForm.shop_id.value"
                    :options="shops"
                    :errors="deliveryForm.shop_id.error ? [deliveryForm.shop_id.error] : []"
                    :searchable="false"
                    :clearable="false"
                    label-name="address"
                    title="Выбор магазина"
                    selectTitle="Магазин"
                  />
                </div>
              </CartDropdownComponent>
              <CartDropdownComponent
                v-if="
                  deliveryForm.delivery_type_id.value &&
                  deliveryForm.delivery_type_id.value.type !== types.PICKUP &&
                  deliveryForm.delivery_type_id.value.type !== types.CDEK_DELIVERY &&
                  deliveryForm.delivery_type_id.value.type !== types.CUSTOM_DELIVERY
                "
                title="Адрес доставки"
              >
                <div v-if="addresses && addresses.length" class="cart-page__address">
                  <RadioComponent
                    v-for="(item, i) in addresses"
                    :key="i"
                    :checked="isChecked(item, 'address')"
                    @change="changeRadio($event, item, 'address')"
                  >
                    {{ item.address }}
                  </RadioComponent>
                </div>
                <span v-else>Адреса отсутствуют</span>
                <span v-if="deliveryForm.address.error">{{ deliveryForm.address.error }}</span>
                <div class="cart-page__address-actions">
                  <button @click.prevent="showAddressModal" type="button" class="btn btn--md btn--main">
                    Добавить адрес
                  </button>
                </div>
              </CartDropdownComponent>
              <!-- CDEK доставка -->
              <div
                v-if="deliveryForm.delivery_type_id.value && deliveryForm.delivery_type_id.value.type === types.CDEK_DELIVERY"
                class="cdek-options">
                <p class="cdek-price-note">от 500 ₽. Точная стоимость доставки рассчитывается отдельно</p>
                <div class="cdek-pvz-selector">
                  <p v-if="cdekPvzAddress" class="cdek-pvz-address">{{ cdekPvzAddress }}</p>
                  <button type="button" @click="openCdekWidget" class="btn btn--md btn--main cdek-pvz-btn">
                    {{ cdekPvzAddress ? 'Поменять адрес' : 'Выбрать адрес' }}
                  </button>
                  <span v-if="cdekPvzError" class="cdek-pvz-error">{{ cdekPvzError }}</span>
                </div>
              </div>

              <!-- Свой вариант доставки -->
              <div
                v-if="deliveryForm.delivery_type_id.value && deliveryForm.delivery_type_id.value.type === types.CUSTOM_DELIVERY"
                class="custom-delivery">
                <TextareaComponent
                  v-model="deliveryCustomComment"
                  title="Укажите удобный способ доставки или пункт выдачи"
                  class="custom-delivery__textarea"
                />
              </div>

              <!-- CDEK Widget Modal -->
              <div v-show="cdekWidgetVisible" class="cdek-modal-overlay" @click.self="cdekWidgetVisible = false">
                <div class="cdek-modal">
                  <button class="cdek-modal__close" type="button" @click="cdekWidgetVisible = false">×</button>
                  <div id="cdek-map-widget" style="height: 600px; width: 100%; display: block;"></div>
                </div>
              </div>

              <CartDropdownComponent title="Способ оплаты">
                <div class="cart-page__methods">
                  <RadioComponent
                    v-for="(item, i) in payments"
                    :key="i"
                    :checked="isChecked(item, 'payment_type_id')"
                    @change="changeRadio($event, item, 'payment_type_id')"
                    :hideState="true"
                  >
                    <MethodComponent
                      :class="{ 'method--active': isChecked(item, 'payment_type_id') }"
                      :title="item.title"
                      :icon="item.icon"
                      :description="item.description"
                    />
                  </RadioComponent>
                </div>
              </CartDropdownComponent>
              <CartDropdownComponent title="Дополнительная информация">
                <TextareaComponent
                  v-model="deliveryForm.commentary.value"
                  title="Комментарий для курьера"
                  :subtitle="deliveryForm.commentary.message"
                  :error="deliveryForm.commentary.error"
                />
              </CartDropdownComponent>
              <button
                type="button"
                :disabled="loading"
                class="cart-page__submit-mobile btn btn--md btn--main"
                @click="orderCreate"
              >
                <FileIconComponent v-if="loading" name="loading"/>
                <template v-else>Оформить заказ</template>
              </button>
            </div>
          </div>
          <CartPageAsideComponent
            :loading="loading"
            :delivery="deliveryForm.delivery_type_id.value"
            :use-bonuses="use_bonuses"
            @pay="orderCreate"
            @setPromocode="setPromocode"
            @removePromocode="removePromocode"
            @update:use-bonuses="use_bonuses = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CartPageAsideComponent from "./components/AsideComponent.vue";
import MethodComponent from "./components/MethodComponent.vue";
import InputComponent from "components/inputs/InputComponent.vue";
import RadioComponent from "components/inputs/RadioComponent.vue";
import ORDER_CREATE from "@/graphql/mutations/OrderCreate.graphql";
import LoginModal from "components/modals/components/LoginModal.vue";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import ProductsTableComponent from "components/ProductsTableComponent.vue";
import CartDropdownComponent from "./components/CartDropdownComponent.vue";
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";
import SelectComponent from "components/inputs/select/index.vue";
import TextareaComponent from "components/inputs/TextareaComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";
import AddressModal from "components/modals/components/AddressModal.vue";
import ShareCartModal from "components/modals/components/ShareCartModal.vue";
import SHARED_CART_QUERY from "@/graphql/queries/get_shared_cart.graphql";

async function load(apollo, store) {
  const cart = store.dispatch("GET_CART_ITEMS", {
    apollo: apollo.defaultClient,
  });
  const addresses = store.dispatch("GET_ADDRESSES", {
    apollo: apollo.defaultClient,
  });
  const shops = store.dispatch("GET_SHOPS", {
    apollo: apollo.defaultClient,
  });
  await Promise.all([cart, addresses, shops]);
}

export default {
  name: "CartPage",
  async asyncData({apollo, store}) {
    await load(apollo, store);
  },
  data() {
    return {
      loading: false,
      debounceTimeout: null,
      subscription: true,
      use_bonuses: false,
      payments: [
        {
          title: "Оплата картой онлайн",
          icon: "cards",
          type: this.$store.state._types.ONLINE_CARD_PAY,
        },
        {
          title: "Картой при получении",
          icon: "cards",
          type: this.$store.state._types.OFFLINE_CARD_PAY,
        },
        {
          title: "Наличными при получении",
          icon: "money",
          type: this.$store.state._types.OFFLINE_CASH_PAY,
        },
      ],
      deliveries: [
        {
          title: "Самовывоз",
          icon: "location",
          description: "0 ₽",
          type: this.$store.state._types.PICKUP,
        },
        {
          title: "Курьерская доставка",
          icon: "truck-time",
          description: "от 500 ₽",
          type: this.$store.state._types.COURIER_DELIVERY,
        },
        {
          title: "CDEK",
          icon: "box",
          description: "от 500 ₽",
          type: this.$store.state._types.CDEK_DELIVERY,
        },
        {
          title: "Свой вариант",
          icon: "truck-time",
          description: "по договорённости",
          type: this.$store.state._types.CUSTOM_DELIVERY,
        },
      ],
      cdekSubType: "pvz",
      cdekPvzCode: null,
      cdekPvzAddress: null,
      cdekWidgetVisible: false,
      cdekWidgetInitialized: false,
      cdekPvzError: null,
      deliveryCustomComment: "",
      deliveryForm: {
        shop_id: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        address: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        payment_type_id: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        delivery_type_id: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        // city: {
        //   value: undefined,
        //   error: undefined,
        //   message: undefined,
        //   required: true,
        // },
        // index: {
        //   value: undefined,
        //   error: undefined,
        //   message: undefined,
        //   required: true,
        // },
        street: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        house: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        flat: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        entrance: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        code: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        floor: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
        commentary: {
          value: undefined,
          error: undefined,
          message: undefined,
          required: false,
        },
      },
      recipientForm: {
        name: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        surname: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        patronymic: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        phone: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        email: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
      },
    };
  },
  watch: {
    "$store.state.auth.user"() {
      this.setUserData();
    },
    "$route.name"() {
      this.removePromocode();
    },
    "$route.params"() {
      this.removePromocode();
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.deliveries && this.deliveries.length) {
        this.deliveryForm.delivery_type_id.value = this.deliveries[0];
        this.deliveryForm.shop_id.value = this.shops[0];
        this.deliveryForm.address.value = this.addresses[0];
        this.deliveryForm.payment_type_id.value = this.payments[0];
      }
      this.removePromocode();
    });
    if (this.isRegistered) {
      this.setUserData();
    }
    this.fetchSharedCart();
  },
  computed: {
    cartItems() {
      return this.$store.state.auth.cart.filter((i) => i.item);
    },
    isRegistered() {
      return !!this.$store.state.apollo_token || this.user;
    },
    // deliveries() {
    //   return this.$store.state.auth.deliveries;
    // },
    types() {
      return this.$store.state._types;
    },
    shops() {
      return this.$store.state.baby_shops || [];
    },
    addresses() {
      return this.$store.state.auth.addresses || [];
    },
    user() {
      return this.$store.state.auth.user;
    },
    links() {
      return [{title: "Оформление заказа"}];
    },
  },
  methods: {
    /**
     * Вывод скидки по промокоду
     */
    setPromocode(share, promocode) {
      this.deliveryForm.promocode.value = promocode;
      let promoProducts = share.products.map((p) => p.id);
      this.cartItems.forEach((c) => {
        if (promoProducts.includes(c.item?.id)) {
          c.item.promo_share = {share};
        }
      });
    },
    /**
     * Удаление промокода
     */
    removePromocode() {
      this.cartItems.forEach((c) => {
        delete c.item.promo_share;
      });
    },
    /**
     * Подставить личные данные
     */
    setUserData() {
      if (this.user) {
        this.recipientForm.name.value = this.user.name;
        this.recipientForm.surname.value = this.user.surname;
        this.recipientForm.patronymic.value = this.user.patronymic;
        this.recipientForm.email.value = this.user.email;
        this.recipientForm.phone.value = this.user.phone;
      }
    },
    /**
     * Оплата
     */
    orderCreate() {
      if (this.isRegistered) {
        if (!this.loading) {
          this.loading = true;
          this.resetErrors("deliveryForm");
          this.resetErrors("recipientForm");
          let errorsCount = 0;
          Object.keys(this.deliveryForm).forEach((key) => {
            if (this.deliveryForm[key].required && !this.deliveryForm[key].value) {
              this.deliveryForm[key].error = "Заполните поле";
              errorsCount += 1;
            }
          });
          // Валидация CDEK ПВЗ
          const isCdek = this.deliveryForm.delivery_type_id.value &&
            this.deliveryForm.delivery_type_id.value.type === this.types.CDEK_DELIVERY;
          const isCustom = this.deliveryForm.delivery_type_id.value &&
            this.deliveryForm.delivery_type_id.value.type === this.types.CUSTOM_DELIVERY;
          if (isCdek && this.cdekSubType === "pvz" && !this.cdekPvzCode) {
            this.cdekPvzError = "Выберите пункт выдачи CDEK";
            errorsCount += 1;
          } else {
            this.cdekPvzError = null;
          }

          if (!errorsCount) {
            this.$apollo
              .mutate({
                mutation: ORDER_CREATE,
                variables: {
                  name: this.recipientForm.name.value,
                  surname: this.recipientForm.surname.value,
                  patronymic: this.recipientForm.surname.value,
                  phone: this.recipientForm.phone.value
                    ? "+" + this.recipientForm.phone.value.replace(/\D+/g, "")
                    : null,
                  email: this.recipientForm.email.value,
                  commentary: this.deliveryForm.commentary.value,
                  // address: this.getUserAddress(),
                  address: isCdek
                    ? this.cdekPvzAddress
                    : isCustom
                      ? null
                      : this.deliveryForm.address.value?.address,
                  delivery_type_id: this.deliveryForm.delivery_type_id.value
                    ? this.deliveryForm.delivery_type_id.value.type
                    : null,
                  payment_type_id: this.deliveryForm.payment_type_id.value
                    ? this.deliveryForm.payment_type_id.value.type
                    : null,
                  use_bonuses: this.use_bonuses,
                  cdek_sub_type: isCdek ? this.cdekSubType : null,
                  cdek_pvz_code: isCdek && this.cdekSubType === "pvz" ? this.cdekPvzCode : null,
                  cdek_pvz_address: isCdek ? this.cdekPvzAddress : null,
                  delivery_custom_comment: this.deliveryForm.delivery_type_id.value &&
                  this.deliveryForm.delivery_type_id.value.type === this.types.CUSTOM_DELIVERY
                    ? this.deliveryCustomComment : null,
                },
                context: {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.apollo_token,
                  },
                },
              })
              .then(({data}) => {
                this.loading = false;
                // проверка, выбрал ли пользователь оплату онлайн
                // лучше переделать на проверку на наличие ссылки,
                // т.к. способ поменяется если он выберет другой после клика "оформить заказ"
                // if (
                //   this.deliveryForm.payment_type_id.value &&
                //   this.deliveryForm.payment_type_id.value.type === this.$store.state._types.ONLINE_CARD_PAY
                // ) {
                if (data && data.OrderCreate) {
                  // Очищаем корзину в Vuex и localStorage после успешного оформления заказа
                  this.$store.state.auth.cart = [];
                  // Всегда идём на страницу подтверждения заказа — оплата производится оттуда
                  this.$router.push({
                    name: "thank-you",
                    query: {
                      id: data.OrderCreate.id,
                      date: new Date().toISOString(),
                      type: this.deliveryForm.payment_type_id.value
                        ? this.deliveryForm.payment_type_id.value.type
                        : null,
                      payment_url: data.OrderCreate.payment_url || undefined,
                    },
                  });
                }
                // }
              })
              .catch(({graphQLErrors}) => {
                this.loading = false;
                if (graphQLErrors && graphQLErrors.length) {
                  let hasValidation = false;

                  graphQLErrors.forEach((err) => {
                    if (err?.extensions?.category === "validation") {
                      hasValidation = true;
                    }
                  });

                  if (hasValidation) {
                    this.parseGqlErrors(graphQLErrors);
                    this.scrollTo("recipientForm");
                  } else {
                    let errorMessage = graphQLErrors[0].message || "Пожалуйста, попробуйте позже";

                    if (graphQLErrors[0].debugMessage) {
                      errorMessage = graphQLErrors[0].debugMessage;
                    }

                    this.$notify({
                      title: "Ошибка",
                      text: errorMessage,
                      duration: 5000,
                      speed: 200,
                      type: "error",
                    });
                  }
                } else {
                  this.$notify({
                    title: "Ошибка",
                    text: "Пожалуйста, попробуйте позже",
                    duration: 3000,
                    speed: 200,
                    type: "error",
                  });
                }
              });
          } else {
            this.loading = false;
            this.scrollTo("deliveryForm");
          }
        }
      } else {
        this.$store.state._modals.push({
          component: LoginModal,
          options: {
            routeAfterLogin: {
              name: this.$router.currentRoute.name,
              params: this.$router.currentRoute.params,
              hash: this.$router.currentRoute.hash,
            },
            callback: () => load(this.$apolloProvider, this.$store),
          },
        });
      }
    },
    // getUserAddress() {
    //   let addressParts = [this.deliveryForm.index.value ? "индекс " + this.deliveryForm.index.value : null];
    //   if (this.deliveryForm.address.value && this.deliveryForm.address.value.address) {
    //     addressParts = [this.deliveryForm.address.value.address, ...addressParts];
    //     return addressParts.filter((i) => i).join(", ");
    //   }
    //   return null;
    //   // else {
    //   //   addressParts = [
    //   //     this.deliveryForm.city.value ? "город " + this.deliveryForm.city.value : null,
    //   //     this.deliveryForm.street.value ? "улица " + this.deliveryForm.street.value : null,
    //   //     this.deliveryForm.house.value ? "дом " + this.deliveryForm.house.value : null,
    //   //     this.deliveryForm.entrance.value ? "подъезд " + this.deliveryForm.entrance.value : null,
    //   //     this.deliveryForm.code.value ? "код " + this.deliveryForm.code.value : null,
    //   //     this.deliveryForm.floor.value ? "этаж " + this.deliveryForm.floor.value : null,
    //   //     this.deliveryForm.flat.value ? "квартира " + this.deliveryForm.flat.value : null,
    //   //     ...addressParts,
    //   //   ];
    //   // }
    // },
    /**
     * Изменение количества товаров в корзине
     * @param items
     * @returns {Promise<void>}
     */
    async countChange(items) {
      // изменение на фронте до запроса, чтобы быстрее отобразилось
      const cart = this.$store.state.auth.cart.filter((i) => i.item);
      items.forEach((item) => {
        cart.find((c) => c.item.id === item.id).count = item.count;
      });
      // костыль, изменяем массив, чтобы вызвался watch в App.vue
      // и сохранил изменения в localStorage
      this.$store.state.auth.cart.push({});
      this.$store.state.auth.cart.pop();

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        if (this.isRegistered) {
          this.$store.dispatch("CART_ADD_ITEMS", {
            apollo: this.$apollo,
            variables: {
              items: items,
            },
          });
        }
      }, 500);
    },
    showLoginModal() {
      this.$store.state._modals.push({
        component: LoginModal,
        options: {
          routeAfterLogin: {
            name: this.$route.name,
            params: this.$route.params,
            hash: this.$route.hash,
          },
          callback: () => load(this.$apolloProvider, this.$store),
        },
      });
    },
    showAddressModal() {
      if (this.isRegistered) {
        this.$store.state._modals.push({
          component: AddressModal,
          options: {},
          stretch: true,
        });
      } else {
        this.showLoginModal();
      }
    },
    /**
     * Удаление товаров в корзине
     * @param ids
     * @returns {Promise<void>}
     */
    async remove(ids = []) {
      this.$store.state.auth.cart = this.$store.state.auth.cart.filter((c) =>
        c.id ? !ids.includes(c.id) : !ids.includes(c.item.id)
      );
      if (this.isRegistered) {
        await this.$store.dispatch("CART_DELETE_ITEMS", {
          apollo: this.$apollo,
          variables: {
            id: ids,
          },
        });
      }
    },
    /**
     * Инициализация виджета CDEK
     */
    openCdekWidget() {
      this.cdekWidgetVisible = true;
      if (!this.cdekWidgetInitialized) {
        this.$nextTick(() => {
          this.initCdekWidget();
        });
      }
    },
    setupCdekFetchInterceptor() {
      if (this._cdekFetchIntercepted) return;
      this._cdekFetchIntercepted = true;
      // Начальный bbox — Дагестан (lng_min,lat_min,lng_max,lat_max)
      this._cdekBbox = "44.5,41.0,49.5,44.5";
      const vm = this;
      const originalFetch = window.fetch;
      window.fetch = function (url, options) {
        if (typeof url === "string" && url.includes("service.php") && url.includes("action=offices") && !url.includes("size=1")) {
          url = url + "&bbox=" + vm._cdekBbox;
        }
        return originalFetch.apply(this, [url, options]);
      };
    },
    initCdekWidget() {
      if (typeof window === "undefined") return;
      if (!window.CDEKWidget) {
        console.error("CDEK widget not loaded");
        return;
      }
      this.setupCdekFetchInterceptor();
      this.cdekWidgetInitialized = true;
      const vm = this;
      this._cdekWidgetInstance = new window.CDEKWidget({
        root: "cdek-map-widget",
        apiKey: "c5ba8ad1-d002-49b3-ae67-db98ac46c0ed",
        servicePath: "https://babymarket05.ru/service.php",
        defaultLocation: "Махачкала",
        onChoose(type, tariff, address) {
          if (type === "office") {
            // Пункт выдачи CDEK
            vm.cdekSubType = "pvz";
            vm.cdekPvzCode = address.code;
            vm.cdekPvzAddress = [address.city, address.address].filter(Boolean).join(", ");
          } else {
            // Курьерская доставка CDEK (door)
            vm.cdekSubType = "courier";
            vm.cdekPvzCode = null;
            vm.cdekPvzAddress = address.formatted || [address.city, address.name].filter(Boolean).join(", ");
          }
          vm.cdekPvzError = null;
          vm.cdekWidgetVisible = false;
        },
      });
    },
    /**
     * Изменение способа доставки
     * @param e
     * @param item
     * @param field
     */
    changeRadio(e, item, field) {
      if (e) {
        this.deliveryForm[field].value = item;
      }
    },
    isChecked(item, field) {
      return JSON.stringify(this.deliveryForm[field].value) === JSON.stringify(item);
    },
    /**
     * Скролл до нужного элемента
     * @param refName
     */
    scrollTo(refName) {
      window.scrollTo({top: this.$refs[refName].offsetTop, behavior: "smooth"});
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.recipientForm[key]) {
              this.recipientForm[key].error = err.extensions.validation[key][0];
            }
          });
        }
      });
    },
    resetErrors(form) {
      Object.keys(this[form]).forEach((key) => {
        this[form][key].error = undefined;
      });
    },
    async fetchSharedCart() {
      const hash = this.$route.query.hash;

      if (!hash) {
        return;
      }
      this.loading = true;

      await load(this.$apollo.provider, this.$store);

      this.$apollo.provider.defaultClient
        .query({
          query: SHARED_CART_QUERY,
          variables: {
            hash: hash,
          },
          fetchPolicy: "network-only",
        })
        .then(({data}) => {
          if (data && data.sharedCart && data.sharedCart.items) {
            const sharedCartItems = data.sharedCart.items.map((item) => ({
              id: item.id,
              count: item.quantity,
              item: item.product,
            }));

            this.$store.state._modals.push({
              component: ShareCartModal,
              options: {
                cartItems: sharedCartItems,
                isSharedCart: true,
              },
              onClose: () => {
                // Удаляем hash из URL при закрытии модалки
                const query = {...this.$route.query};
                delete query.hash;
                this.$router.replace({query});
              },
            });
          }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch(({graphQLErrors}) => {
          this.loading = false;
          this.$notify({
            type: "error",
            title: "Ошибка",
            text: graphQLErrors[0].message,
          });
        });
    },
  },
  metaInfo: {
    title: "Корзина",
  },
  components: {
    FileIconComponent,
    TextareaComponent,
    SelectComponent,
    CheckboxComponent,
    CartDropdownComponent,
    MethodComponent,
    ProductsTableComponent,
    BreadcrumbsComponent,
    RadioComponent,
    InputComponent,
    CartPageAsideComponent,
  },
};
</script>

<style lang="stylus">
.cart-page {
  width 100%
  display grid
  grid-gap 50px
  +below(680px) {
    padding 30px 0
  }

  &__container {
    display grid
    align-items start
    gap 24px
  }

  &__title {
    font-weight: normal;
    font-size: 2.25em;
    line-height: 50px;
    display: flex;
    align-items: center;
    margin 0
    color: var(--body-color);
  }

  &__content {
    display grid
    grid-gap 70px
    grid-template-columns 2fr 1fr
    align-items start
    +below(1200px) {
      grid-gap 50px
    }
    +below(990px) {
      display flex
      flex-direction column-reverse
      align-items stretch
      grid-gap 30px
    }
  }

  .form__col-4 {
    +below(716px) {
      gap 16px
      flex-basis calc(100% - 16px)
    }
  }

  .form__col-6 {
    +below(540px) {
      gap 16px
      flex-basis calc(100% - 16px)
    }
  }

  &__body {
    display grid
    grid-gap 54px

    .form__row .input {
      width 100%
    }
  }

  &__dropdowns {
    display grid
    grid-gap 30px
  }

  &__methods {
    display grid
    grid-template-columns repeat(3, 1fr)
    grid-gap 20px 30px
    +below(768px) {
      grid-template-columns 1fr
      grid-gap 15px
    }
  }

  &__shop {
    padding 15px
    border-radius var(--main_radius)
    background: var(--gray);
    border: 1px solid var(--main-color-75);
  }

  &__address {
    .radio {
      font-size 1em
      padding 13px 20px
      border-bottom 1px solid var(--main-color-75)
      display flex
      align-items center

      &:hover {
        background var(--gray)
      }
    }

    &-actions {
      display flex
      justify-content flex-end
    }
  }

  &__submit-mobile {
    +above(991px) {
      display none
    }
  }
}

.cdek-options {
  padding 15px
  border-radius var(--main_radius)
  background var(--gray)
  border 1px solid var(--main-color-75)
  display flex
  flex-direction column
  gap 12px
}

.cdek-subtypes {
  display flex
  flex-direction column
  gap 8px

  &__label {
    display flex
    align-items center
    gap 8px
    cursor pointer
    font-size 1em
  }

  &__radio {
    cursor pointer
  }
}

.cdek-price-note {
  font-size 0.875em
  color var(--main-color-75)
  margin 0
}

.cdek-pvz-selector {
  display flex
  flex-direction column
  gap 6px
}

.cdek-pvz-address {
  margin 0
  font-size 0.9375rem
  color var(--main-color)
  font-weight 500
}

.cdek-pvz-btn {
  align-self flex-start
}

.cdek-pvz-error {
  color var(--red)
  font-size 0.875em
}

.custom-delivery {
  padding 15px
  border-radius var(--main_radius)
  background var(--gray)
  border 1px solid var(--main-color-75)

  &__textarea {
    width 100%
  }
}

.cdek-modal-overlay {
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0, 0, 0, 0.6)
  z-index 9999
  display flex
  align-items center
  justify-content center
}

.cdek-modal {
  background var(--white)
  border-radius var(--main_radius)
  width 90vw
  max-width 900px
  padding 10px 0 0
  max-height 90vh
  overflow hidden
  position relative
  display flex
  flex-direction column

  &__close {
    position absolute
    top 10px
    right 14px
    background transparent
    border none
    font-size 1.75em
    cursor pointer
    z-index 1
    line-height 1
    color var(--main-color)
    padding 4px 8px

    &:hover {
      color var(--main-color-75)
    }
  }
}
</style>
